import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { TagService } from '../services/tag.service';
import { EvendProductTag } from "../models/evendProduct";

declare var $: any;

@Component({
  selector: 'app-product-tag',
  templateUrl: './product-tag.component.html',
  styleUrls: ['./product-tag.component.scss']
})
export class ProductTagComponent implements OnInit {
  @ViewChild('errorSwal') private errorSwal: SwalComponent;
  @ViewChild('successSwal') private successSwal: SwalComponent;

  @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
  @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;

  page = 1;
  pages = 1;

  searchText: string;

  evendProductTags = [new EvendProductTag()];
  newEvendProductTag = new EvendProductTag();
  editEvendProductTag = new EvendProductTag();

  editModelName = ''; // Edit product modal title
  errorMessage = '';
  constructor(
      private route: ActivatedRoute, 
      private router: Router,
      private spinner: NgxSpinnerService,
      private tagService: TagService
      ) { }


  ngOnInit() {
    this.getevendProductTags();
  }

  setModel(model) {
      console.log(model);
      this.clearModel();
      this.editEvendProductTag = Object.assign({}, model);
      //this.editModelName = model.name;
  }

getevendProductTags() {
    this.tagService.getAllTags(this.page).subscribe(res => {
      this.evendProductTags = res.docs;
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
      } else {
        if (this.errorSwal) {                
            this.errorSwal.title = error.status;
            this.errorSwal.text = error.error;
            this.errorSwal.show();
        }
        console.log('Error:', error);
      }
    });
}

createEvendProductTag() {
    if (!this.checkIsFieldsOkay(false))  { return ; }
    if (this.isExist(this.newEvendProductTag.name, 0)) { return; }
    this.tagService.createTag(this.newEvendProductTag).subscribe(response => {
      this.spinner.hide();
      this.successSwal.text = 'Ürün türü başarıyla oluşturuldu!';
      this.successSwal.show();
      this.closeCreateModal.nativeElement.click();
      this.getevendProductTags();
    }, error => {
      this.spinner.hide();
      if (this.errorSwal) {
          this.errorSwal.text = 'Ürün türü oluşturulurken hata oluştu!';
          this.errorSwal.show();
      }
    });
    this.clearEvendProductTag();
}

updateEvendProductTag() {
    if (!this.checkIsFieldsOkay(true)) {  return; }
    if (this.isExist(this.editEvendProductTag.name, this.editEvendProductTag._id)) { return; }
    this.spinner.show();
    this.tagService.updateTag(this.editEvendProductTag, this.editEvendProductTag._id).subscribe(res => {
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.closeUpdateModal.nativeElement.click();
      this.getevendProductTags();
      this.clearEvendProductTag();
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
}

deleteEvendProductTag(id) {
    if (id === '' || id === undefined) {
        if (this.errorSwal) {                
            this.errorSwal.title = 'Ürün id alınamadı!';
            this.errorSwal.show();
        }
      return;
    }
    this.spinner.show();
    this.tagService.deleteTag(id).subscribe(res => {
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.getevendProductTags();
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
          if (this.errorSwal) {                  
              this.errorSwal.title = error.status;
              this.errorSwal.text = error.error;
              this.errorSwal.show();
          }
        this.spinner.hide();
      }
    });
}

isExist(name, id) {
  const result =  this.evendProductTags.some(tag =>  {
      if (tag.name && tag._id) {
        tag.name.toLowerCase() === name.toLowerCase() && tag._id !== id
      }
      return result;
  });
  if (result) {
    this.errorMessage = 'Bu isimli bir ürün türü mevcuttur!';
    this.spinner.hide();
  }
  return result;
}

checkIsFieldsOkay(isEdit: boolean): boolean {
  let isOkay = true;
  if (isEdit) {
    console.log(this.editEvendProductTag);
    if (this.editEvendProductTag.name === '' || this.editEvendProductTag.name === undefined ) { isOkay = false; }
  } else {
    console.log(this.newEvendProductTag);
      if (this.newEvendProductTag.name === '' || this.newEvendProductTag.name === undefined ) { isOkay = false; }
  }
  if (!isOkay) {
      if (this.errorSwal) {                
          this.errorSwal.text = 'Lütfen tüm alanları doldurunuz ve negatif değerler girmeyiniz!';
          this.errorSwal.show();
      }
    return false;
  } else {
    return true;
  }
}

clearEvendProductTag() {
  this.newEvendProductTag = new EvendProductTag();
  this.newEvendProductTag = new EvendProductTag();
  this.errorMessage = '';
}

onScroll() {
  if (this.page + 1 > this.pages) { return; }
  $('#page-loader').fadeIn();
  this.page += 1;
  this.tagService.searchTag(this.searchText)
      .subscribe(response => {
          $('#page-loader').fadeOut();
          for (const item of response.docs) {
              this.evendProductTags.push(item);
          }
          this.pages = response.pages;
      }, error => {
          $('#page-loader').fadeOut();
          this.errorSwal.text = 'Ürünlerin devamı yüklenemedi!';
          this.errorSwal.show();
      });
}

searchProduct(value) {
  this.spinner.show();
  this.page = 1;
  this.tagService.searchTag(this.searchText)
      .subscribe((response) => {
          this.evendProductTags = response.docs;
          this.pages = response.pages;
          this.spinner.hide();
      }, error => {
          this.spinner.hide();
          this.errorSwal.text = 'Arama sonuçları getirilirken hata oluştu!';
          this.errorSwal.show();
      });
  this.spinner.hide();
}

clearTag() {
  this.newEvendProductTag = new EvendProductTag();
  this.editEvendProductTag = new EvendProductTag();
  this.errorMessage = '';
}

  clearModel() {}

}
export class itemModel{
  name?: string;
}


// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/product-tag/product-tag.component.ts